import { Avatar, Box, Button, Flex, Image, Text } from "@chakra-ui/react";
import iconApproved from "../../assets/images/receiveSalary/check-circle.svg";
import iconRejected from "../../assets/images/contract/x-circle.svg";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { RiResetLeftFill } from "react-icons/ri";
import { ParticipantList } from "../../components/table/participantList";

const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const openTransactionDetailModal = ({ id, status, submit }) => {
  window.dispatchEvent(
    new CustomEvent("OPEN_TRANSACTION_DETAIL_MODAL", {
      detail: {
        id,
        type: "TTKQ",
        status,
        submit,
      },
    })
  );
};

export const formatTableValue = (value, key, code, submit, id, revert) => {
  switch (key) {
    case "contact":
      const infos = value?.split("-") || [];

      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {infos?.length &&
            infos?.map((item, index) => <Text key={index}>{item}</Text>)}
        </Flex>
      );

    case "bankInfo":
      const bankInfo = value?.split("-") || [];

      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {bankInfo?.length &&
            bankInfo?.map((item, index) => <Text key={index}>{item}</Text>)}
        </Flex>
      );

    case "identificationNumberInfo":
      const identificationNumberInfo = value?.split("-") || [];

      return (
        <Flex direction={"column"} justifyContent={"left"}>
          {identificationNumberInfo?.length &&
            identificationNumberInfo?.map((item, index) => (
              <Text key={index}>{item}</Text>
            ))}
        </Flex>
      );

    case "avatar":
      return <Avatar src={value} />;

    case "delegationImage":
      if (!value || value?.length == 0) return <Text>{`Không có ảnh`}</Text>;

      return (
        <Flex w={"100%"} justifyContent={"center"}>
          <Button
            bg={"var(--linear-gradient-employee)"}
            color={"var(--color-main)"}
            fontSize={"12px"}
            lineHeight={"17px"}
            fontWeight={"600"}
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={() =>
              downloadImageOrZip(value, `anh_UNC${code ? `_${code}` : ""}`)
            }
            h={"28px"}
            minH={"28px"}
            w={"90px"}
          >
            Tải file xuống
          </Button>
        </Flex>
      );

    case "priceSheetImage":
      if (!value || value?.length == 0) return <Text>{`Không có ảnh`}</Text>;

      return (
        <Flex w={"100%"} justifyContent={"center"}>
          <Button
            bg={"var(--linear-gradient-employee)"}
            color={"var(--color-main)"}
            fontSize={"12px"}
            lineHeight={"17px"}
            fontWeight={"600"}
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={() =>
              downloadImageOrZip(
                value,
                `anh_phieu_tinh_gia${code ? `_${code}` : ""}`
              )
            }
            h={"28px"}
            minH={"28px"}
            w={"90px"}
          >
            Tải file xuống
          </Button>
        </Flex>
      );

    case "salesContractImages":
      if (!value || value?.length == 0) return <Text>{`Không có ảnh`}</Text>;

      return (
        <Flex w={"100%"} justifyContent={"center"}>
          <Button
            bg={"var(--linear-gradient-employee)"}
            color={"var(--color-main)"}
            fontSize={"12px"}
            lineHeight={"17px"}
            fontWeight={"600"}
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={() =>
              downloadImageOrZip(value, `anh_TTKQ${code ? `_${code}` : ""}`)
            }
            h={"28px"}
            minH={"28px"}
            w={"90px"}
          >
            Tải file xuống
          </Button>
        </Flex>
      );

    case "status":
      let content;

      if (value === "NEW") {
        content = (
          <Flex gap={"8px"} w={"max-content"}>
            <Button
              bg={"var(--linear-gradient-employee)"}
              color={"var(--color-main)"}
              fontSize={"12px"}
              lineHeight={"17px"}
              fontWeight={"600"}
              _hover={{
                filter: "brightness(90%)",
              }}
              onClick={() =>
                openTransactionDetailModal({
                  id,
                  status: "APPROVED",
                  submit,
                })
              }
              h={"28px"}
              minH={"28px"}
              w={"90px"}
            >
              Duyệt
            </Button>

            <Button
              bg={"var(--color-main)"}
              color={"var(--color-option-employee-hover)"}
              border={"1px solid var(--color-option-employee-hover)"}
              fontSize={"12px"}
              lineHeight={"17px"}
              fontWeight={"600"}
              _hover={{
                filter: "brightness(90%)",
              }}
              onClick={() => submit("REJECTED", id)}
              h={"28px"}
              minH={"28px"}
              w={"90px"}
            >
              Ko duyệt
            </Button>
          </Flex>
        );
      } else if (value === "APPROVED") {
        content = (
          <Flex gap={"8px"} w={"max-content"}>
            <Image src={iconApproved} />
            <Text color={"var(--color-status-employ)"}>Đã được duyệt</Text>
          </Flex>
        );
      } else if (value === "REFUND") {
        content = (
          <Flex gap={"8px"} w={"max-content"}>
            <Image src={iconApproved} />
            <Text color={"var(--color-status-employ)"}>Đã hoàn trả</Text>
          </Flex>
        );
      } else {
        content = (
          <Flex gap={"8px"} w={"max-content"}>
            <Image src={iconRejected} />
            <Text color={"var(--text-red-employee)"}>Không được phê duyệt</Text>
          </Flex>
        );
      }

      return (
        <Flex gap={"8px"} w={"full"}>
          <Box w={"full"}>{content}</Box>

          {value !== "NEW" && value !== "REFUND" && (
            <Button
              bg={"var(--linear-gradient-employee)"}
              color={"var(--color-main)"}
              fontSize={"12px"}
              lineHeight={"17px"}
              fontWeight={"600"}
              _hover={{
                filter: "brightness(90%)",
              }}
              onClick={() => revert(id)}
              h={"28px"}
              minH={"28px"}
            >
              <RiResetLeftFill size={"18px"} />
            </Button>
          )}
        </Flex>
      );

    case "reviewer":
      return (
        <Box textAlign={"end"}>
          <Text
            fontSize={"14px"}
            lineHeight={"19.6px"}
            fontWeight={"500"}
            color={"var(--color-info-employee)"}
          >
            {value.name}
          </Text>

          <Text
            fontSize={"12px"}
            lineHeight={"16.8px"}
            fontWeight={"400"}
            color={"var(--color-label-employee)"}
          >
            {value.jobTitle}
          </Text>
        </Box>
      );

    case "participants":
      return <ParticipantList value={value} />;

    default:
      return <Text>{value}</Text>;
  }
};

export const downloadImageOrZip = async (input, name) => {
  const URL = baseURL + "/";

  if (typeof input === "string") {
    try {
      const response = await fetch(URL + input);
      const blob = await response.blob();

      let filename;

      if (name) {
        filename = name.endsWith(".jpg") ? name : name + ".jpg";
      } else {
        const original = input.split("/").pop()?.split(".")[0] || "image";
        filename = `${original}.jpg`;
      }

      saveAs(blob, filename);
    } catch (error) {
      console.error("Lỗi khi tải ảnh:", error);
    }
  } else if (Array.isArray(input)) {
    const zip = new JSZip();

    for (const url of input) {
      try {
        const response = await fetch(URL + url);
        const blob = await response.blob();

        const originalName = url.split("/").pop()?.split(".")[0] || "image";
        const filename = `${originalName}.jpg`;

        zip.file(filename, blob);
      } catch (error) {
        console.error("Lỗi khi tải ảnh:", url, error);
      }
    }

    try {
      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, `${name ? name : "anh_hdmb.zip"}`);
    } catch (zipError) {
      console.error("Lỗi khi tạo file ZIP:", zipError);
    }
  } else {
    console.warn("Input không hợp lệ: phải là chuỗi hoặc mảng chuỗi.");
  }
};